import { Component, ComponentInterface, h, Host, JSX, Prop } from '@stencil/core';
import { Rating } from '../eco-rating/eco-rating.types';

const LABEL_PATH_MAP = {
  'A+++': 'm5.36 8.68.43-1.45H8.1l.42 1.45h1.45L7.8 2H6.15L4 8.68h1.36Zm2.43-2.5H6.1l.61-2.08c.09-.3.16-.6.21-.88h.06c.03.18.1.48.21.9l.6 2.06ZM13.98 4.7v.77h-1.56v1.62h-.8V5.47h-1.55V4.7h1.55V3.09h.8V4.7zM18.39 4.7v.77h-1.56v1.62h-.8V5.47h-1.55V4.7h1.55V3.09h.8V4.7zM22.8 4.7v.77h-1.56v1.62h-.8V5.47h-1.55V4.7h1.55V3.09h.8V4.7z',
  'A++': 'm6.36 8.68.43-1.45H9.1l.42 1.45h1.45L8.8 2H7.15L5 8.68h1.36Zm2.43-2.5H7.1l.61-2.08c.09-.3.16-.6.21-.88h.06c.03.18.1.48.21.9l.6 2.06ZM16.06 4.65v.79h-1.59v1.65h-.82V5.44h-1.58v-.79h1.58V3h.82v1.65zM21.06 4.65v.79h-1.59v1.65h-.82V5.44h-1.58v-.79h1.58V3h.82v1.65z',
  'A+': 'm9.36 8.68.43-1.45h2.31l.42 1.45h1.45L11.8 2h-1.65L8 8.68h1.36Zm2.43-2.5H10.1l.61-2.08c.09-.3.16-.6.21-.88h.06c.03.18.1.48.21.9l.6 2.06ZM19.06 4.65v.79h-1.59v1.65h-.82V5.44h-1.58v-.79h1.58V3h.82v1.65z',
  A: 'm11.36 8.68.43-1.45h2.31l.42 1.45h1.45L13.8 2h-1.65L10 8.68h1.36Zm2.43-2.5H12.1l.61-2.08c.09-.3.16-.6.21-.88h.06c.03.18.1.48.21.9l.6 2.06Z',
  B: 'M13.56 8.68c.43 0 .81-.07 1.16-.22.35-.15.63-.37.83-.66.2-.3.31-.65.31-1.07 0-.4-.11-.74-.33-1.02a1.87 1.87 0 0 0-.91-.6v-.05c.3-.13.53-.3.7-.53.17-.24.25-.51.25-.84 0-.5-.2-.91-.63-1.23A2.78 2.78 0 0 0 13.26 2H11v6.68h2.56Zm-.3-3.94h-.9V3.07h.9c.3 0 .52.07.69.22.17.14.25.34.25.61 0 .27-.08.48-.25.63-.17.14-.4.21-.69.21Zm.11 2.87h-1.01V5.75h1.01c.33 0 .6.08.79.23.19.16.28.4.28.7 0 .31-.1.55-.29.7-.19.15-.45.23-.78.23Z',
  C: 'M13.93 8.92a2.56 2.56 0 0 0 2.57-1.83l-1.11-.55c-.14.43-.33.74-.58.94-.25.2-.53.3-.85.3-.47 0-.84-.2-1.12-.58a2.96 2.96 0 0 1-.42-1.74c0-.78.14-1.36.42-1.75.28-.38.65-.57 1.11-.57.65 0 1.11.37 1.37 1.1l1.1-.53c-.2-.57-.52-1-.97-1.28A2.77 2.77 0 0 0 13.92 2a2.75 2.75 0 0 0-2.54 1.61A4.14 4.14 0 0 0 11 5.46c0 .71.13 1.33.38 1.85a2.77 2.77 0 0 0 2.54 1.61Z',
  D: 'M12.28 8.68c.63 0 1.2-.13 1.68-.39a2.7 2.7 0 0 0 1.12-1.14c.27-.5.4-1.11.4-1.81s-.13-1.3-.4-1.8a2.7 2.7 0 0 0-1.13-1.15A3.48 3.48 0 0 0 12.29 2H10v6.68h2.28Zm-.13-1.12h-.77V3.12h.77c.59 0 1.05.2 1.4.58.34.39.51.93.51 1.64 0 .7-.17 1.25-.52 1.64-.34.39-.8.58-1.39.58Z',
  E: 'M15.24 8.68v-1.1h-2.86V5.77h2.6V4.71h-2.6V3.1h2.79V2H11v6.68z',
  F: 'M12.38 8.68V5.94h2.54V4.86h-2.54V3.12h2.73V2H11v6.68z',
  G: 'M13.12 8.92a3.97 3.97 0 0 0 2.49-.85V5.26h-2.62v1.06h1.37v1.1c-.33.25-.76.38-1.27.38-.54 0-.95-.2-1.24-.58-.29-.39-.43-.97-.43-1.76s.15-1.37.45-1.75c.3-.38.7-.57 1.21-.57.66 0 1.14.3 1.44.9l1.07-.61a2.34 2.34 0 0 0-1.02-1.06A3.15 3.15 0 0 0 13.05 2a2.91 2.91 0 0 0-2.65 1.62c-.27.52-.4 1.13-.4 1.84 0 .73.13 1.36.4 1.88.26.52.63.91 1.1 1.18.46.27 1 .4 1.62.4Z',
};

/**
 * @deprecated component will be removed
 */
@Component({
  tag: 'wb-eco-label',
  styleUrl: './eco-label.scss',
  shadow: true,
})
export class EcoLabelComponent implements ComponentInterface {
  /** The eco rating to be applied */
  @Prop({ reflect: true })
  public rating: Rating;

  /** Specify country to match legal requirements */
  @Prop({ reflect: true })
  public country?: 'DE';

  public render(): JSX.Element {
    return (
      <Host class="wb-eco-label">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 11">
          <path class="shape" d="M3.71 0H24v11H3.71L0 5.5z" />
          <g class="label">
            <path d={LABEL_PATH_MAP[this.rating]} />
          </g>
        </svg>
      </Host>
    );
  }
}
